/*
 * Project: BookingEngine
 * Module: components/icons/CheckboxIcon.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';
import PropTypes from 'prop-types';

const tickMark = (props) => (
  <g stroke="none" strokeWidth="1" fill={props.color !== 'none' ? props.color : 'none'} fillRule="evenodd">
    <g className={props.color === 'none' ? 'theme-path' : ''} fillRule="evenodd" transform="translate(-12, -18)">
      <polygon points="15 26 19 26 21 29 29 20 33 20 21 34" />
    </g>
  </g>
);

const CheckboxIcon = (props) => (
  <svg className="svg-icon checkbox-icon" width={props.width} height={props.height} viewBox="0 0 20 20" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fill="#C8C8C8" fillRule="evenodd">
        <path d="M0,0 L20,0 L20,20 L0,20 L0,0 Z M1,1 L1,19 L19,19 L19,1 L1,1 Z" />
        {props.isChecked && tickMark(props)}
      </g>
    </g>
  </svg>
);

CheckboxIcon.propTypes = {
  isChecked: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
};

CheckboxIcon.defaultProps = {
  width: '20px',
  height: '20px',
  color: 'none',
};

export default CheckboxIcon;
